import { render, staticRenderFns } from "./d-admin-exit-modal.vue?vue&type=template&id=0fab0f1e&"
import script from "./d-admin-exit-modal.vue?vue&type=script&lang=js&"
export * from "./d-admin-exit-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports